import {generatePopupHTML} from "app/common/PopupUtil";
import {formatNumber} from "app/common/TooltipUtil";
import {mapOverlayPanes} from "base/component/geo";
import {createLayerLegend, useLayerObject} from "base/map";

const markerBaseOptions = {
    marker: "s",
    fillColor: "#ecd8d1",
    radius: 10,
    color: "#a57b6b",
    addStroke: false,
    weight: 1,
    opacity: 1,
    fillOpacity: 1,
    pane: mapOverlayPanes[11],
    interactive: false,
};

export const LayerLegend = createLayerLegend({
    layerName: "Countries",
    menuIconShape: markerBaseOptions.marker,
    defaultMarkerOptions: markerBaseOptions,
});

export const countriesAndRegionsFieldConfig = [
    {key: "name", label: "Name"},
    {key: "type", label: "Type"},
    {key: "gva_me", label: "Current GVA (€ million)", format: formatNumber},
    {
        key: "gva_per",
        label: "Direct Impact % of national GDP",
        format: formatNumber,
    },
    {key: "di_gva_me", label: "Direct Impact (€ million)", format: formatNumber},
    {
        key: "di_gva_per",
        label: "Indirect and induced % of national GDP",
        format: formatNumber,
    },
    {key: "tii_gva_me", label: "Total Impact (€ million)", format: formatNumber},
    {key: "tii_gva_per", label: "Total Impact % of national GDP", format: formatNumber},
    {key: "emp_n", label: "Current Employment (Nº Persons)", format: formatNumber},
    {
        key: "emp_per",
        label: "Indirect and induced Employment in the country",
        format: formatNumber,
    },
    {
        key: "di_emp_n",
        label: "Direct Impact Employment (Nº Persons)",
        format: formatNumber,
    },
    {key: "di_emp_per", label: "Direct Impact Employment (%)", format: formatNumber},
    {key: "tii_emp_n", label: "Total Employment (Nº Persons)", format: formatNumber},
    {key: "tii_emp_per", label: "Total Employment (%)", format: formatNumber},
    {key: "top5", label: "Top 5 non-MSP sectors impacted"},
];

// Separate function for tooltip content
const createCountriesAndRegionsTooltip = data => {
    return generatePopupHTML("Countries", data, countriesAndRegionsFieldConfig);
};

// eslint-disable-next-line no-unused-vars
export function useCountriesLayer(onSelectElement) {
    return useLayerObject({
        legend: LayerLegend,
        detail: false,
        getTooltip: ({feature}) => {
            let data = feature.properties;
            return createCountriesAndRegionsTooltip(data);
        },
    });
}
